import axios from "axios";
import { useQuery } from "react-query";

// eslint-disable-next-line import/prefer-default-export
export function useGetIntegrationQuery(integrationId, options) {
    return useQuery(
        ["integration", integrationId],
        async () => await axios.get(`/integration/${integrationId}`),
        options
    );
}
